import { Controller } from '@hotwired/stimulus';
import { withProfiler } from '@sentry/react';
import { Root, createRoot } from 'react-dom/client';

import { App, createRouter } from '../features/app/App';

const AppWithProfiler = withProfiler(App, { name: 'B4BApp' });

export default class extends Controller {
  root?: Root;

  connect() {
    const router = createRouter();

    this.root ??= createRoot(this.element);
    this.root.render(<AppWithProfiler router={router} employerId={this.employerId!} />);
  }

  disconnect() {
    this.root?.unmount();
    this.root = undefined;
  }

  get employerId() {
    return this.data.get('employer-id');
  }
}
